import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EventsService } from '../../../events.service';
import { GlobalService } from '../../../../global.service';
declare const lightMain: any;


@Component({
  selector: 'app-ramadan-home',
  templateUrl: './ramadan-home.component.html',
  styleUrls: ['./ramadan-home.component.css']
})
export class RamadanHomeComponent implements OnInit {

  language: any;
  langChosen: string = 'en';

  games: Array<any> = [
    ['crossfire', 'crossfire', '10 Tournaments', 'PC'],
    ['pubg-lite', 'pubg lite', '4 Tournaments', 'PC'],
    ['rainbow-six-siege', 'rainbow six siege', '4 Tournaments', 'PC'],
    ['fortnite', 'Fortnite', '10 Tournaments', 'CROSS'],
    ['pubg', 'pubg mobile', '10 Tournaments', 'MOBILE'],
    ['league-of-legends', 'League Of Legends', '3 Tournaments', 'PC'],
    ['clash-royale', 'Clash royale', '7 Tournaments', 'MOBILE'],
    ['brawl-stars', 'Brawl Stars', '3 Tournaments', 'MOBILE']

  ];

  mobileView: boolean = false;

  constructor(private router: Router, private activeRoute: ActivatedRoute, public eventService: EventsService, public globalService: GlobalService) {
    if (globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }

  }

  ngOnInit() {


    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./../dictionary/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('./../dictionary/en.json');
      }
    }


    this.eventService.insomniaGame = this.router.url.split('/')[2];

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.eventService.insomniaGame = event.url.split('/')[2];
      }
    });

    lightMain();

  }


  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.langChosen = value;
      this.language = require('./../dictionary/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }


}
